var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"disclaimer"},[_vm._v("Due to variations in monitor and browser settings, product images may vary from actual finishes. We recommend contacting one of our dealers to view actual finish samples.")])
}
var staticRenderFns = []

export { render, staticRenderFns }